// 权限对应api 路由
export const apiRoute = {
  commonUpload: 'common-upload', // 上传
  commonConfig: 'common-config', // 配置
  commonLog: 'common-log', // 配置日记
  monitor: 'common-monitor', // 监控

  // 后台登录用户
  adminLogin: 'login',
  adminUserForget: 'admin-user-forget',
  adminUserDetail: 'admin-user-detail',
  adminUserEdit: 'admin-user-edit',

  // 后台用户管理
  adminAdd: 'admin-add',
  adminEdit: 'admin-edit',
  adminU: 'admin-u',
  adminLog: 'admin-log',
  adminLogExport: 'admin-log-export', // 导出
  adminRemove: 'admin-remove',
  adminQrGoogle: 'captcha-google-qr',

  // 配置
  configList: 'system',
  configEdit: 'system-edit',
  botGroup: 'bot-group',
  btDomain: 'bt-domain',
  buildApk: 'jenkins-build-apk',
  safeApk: 'safe-apk', // 加固apk
  btCreateSite: 'bt-create-site', // 创建宝塔站点
  btUpdateNginxConfig: 'bt-update-nginx', // 更新nginx配置
  serverSelect: 'server-select', // 服务器选择
  gitFileList: 'git-file-list', // 落地页文件列表
  ployPage: 'ploy-page', // 部署落地页
  updatePage: 'update-page', // 更新落地页
  removePage: 'remove-page', // 卸载落地页
  updateCommon: 'update-common', // 更新comm

  // 银行
  bankList: 'common-bank-list', // 银行列表
  bankRemove: 'common-bank-remove', // 银行列表
  bankEdit: 'common-bank-edit', // 银行编辑
  bankAdd: 'common-bank-add', // 银行编辑

  // 账号管理
  accountsList: 'accounts-list', // 账号列表
  accountsAdd: 'accounts-add', // 账号新增
  accountsRemove: 'accounts-remove', // 账号移除
  accountsEdit: 'accounts-edit', // 账号修改

  // 域名解析记录管理
  domainLogList: 'domain-log-list', // 域名解析记录列表
  domainResolver: 'domian-resolver', // 批量解析
  domainResolverEdit: 'domian-resolver-edit', // 单域名解析
  domainFense: 'domian-defense', // 解析按钮
  // 系统-域名解析
  platformAccount: 'platform-account',
  cfAccount: 'cf-account',
  resolverLog: 'resolver-log',

  // 服务器管理
  serverListPage: 'server-list-page',
  serverAdd: 'server-add',
  serverEdit: 'server-edit',
  serverRemove: 'server-remove',
  serverGetId: 'server-get-id', // 详情
  serverList: 'server-list', // 全部服务器列表
  serverEditBatch: 'server-edit-batch', // 批量编辑状态
  serverKey: 'server-key', // 获取密钥
  serverTest: 'server-test', // 测试连通性
  ployServer: 'ploy-server', // 部署服务器环境
  serverSftpList: 'server-sftp-list', // SFTP列表
  serverFileRead: 'server-file-read', // 读取文件
  serverFileSave: 'server-file-save', // 保存文件

  // 库
  packageList: 'common-package-list', // 库列表
  packageEdit: 'common-package-edit', // 库编辑
  packageAdd: 'common-package-add', // 库新增
  packageRemove: 'common-package-remove', // 库删除
  commonApk: 'common-apk', // 包上传
  commonPageRemove: 'common-page-remove', // 删除落地页配置

  siteStatistics: 'common-statistics-report', // 获取保活统计
  siteBusiness: 'common-business-report', // 获取业务统计
  mirrorStatisticsReport: 'mirror-statistics-report', // 获取镜像统计
  mirrorStatisticsList: 'mirror-statistics-list', // 获取镜像列表
  commonGetSystemStatistics: 'common-get-system-statistics', // 落地页统计

  // 站点
  siteList: 'site-list', // 站点列表
  selectSite: 'select-site', // 站点选项
  siteEdit: 'site-update', // 站点修改
  siteRemove: 'site-remove', // 站点移除
  siteConfigSave: 'site-config-save', // 站点配置保存
  siteOpen: 'site-open', // 虚拟接口，打开其他后台所需权限

  siteSystemRestart: 'common-site-restart', // 重启服务
  siteSendSql: 'common-sync-sql', // SQL同步
  siteSendBank: 'common-sync-bank', // 同步银行
  siteGetConf: 'common-get-siteconf', // 获取配置
  countryList: 'common-country', // 获取国家
  getSiteSystem: 'common-get-system', // 获取下配置
  syncSiteSystem: 'common-sync-system', // 同步一下配置
  siteBuildApk: 'common-build-apk', // 构建一下apk

  // 固定
  rbacMenuList: 'rbac-menu-list',
  rbacMenuAdd: 'rbac-menu-add',
  rbacMenuEdit: 'rbac-menu-edit',
  rbacMenuRemove: 'rbac-menu-remove',
  rbacGroupAdd: 'rbac-group-add', // 组添加权限
  rbacGroupMenu: 'rbac-group-menu', // 获取指定组数据
  rbacAdminGroup: 'rbac-admin-group', // 登陆获取目录权限

  // 监控
  adminMonitorList: 'common-admin-mnitor-list',
  commandScreenUp: 'command-screen-up',
  commonAdminU: 'common-admin-u'
} as const;
export const values = Object.values(apiRoute);

// eslint-disable-next-line prettier/prettier
export type apiRoutePermsType = typeof values[number];

export default apiRoute;
